import { Helmet } from 'react-helmet-async';

import DealerRequiredPageShell from 'app/components/ReusableUIComponents/HighLevelComponents/DealerRequiredPageShell';
import { DealerPageHeaderEntityInfo } from 'app/components/ReusableUIComponents/LowLevelComponents/PageHeaderEntityInfo';
import { withResourceProtection } from 'app/components/ReusableUIComponents/HOCs/ResourceProtected/withResourceProtection';
import { DealerNurturingAutomationSettingsComponent } from 'app/pages/DealerNurturingAutomationSettingsComponent';
import { CONFIGURE_RESOURCE_NURTURING_AUTOMATION } from 'app/pages/ConfigurePage/utils/configureResourceIds';

import { useNurturingAutomationConfigurationPage } from './hooks/useNurturingAutomationConfigurationPage';

const NurturingAutomationConfigurationPage = () => {
  const { breadcrumbsList, hasDealer, dealerTitle, dealerId } =
    useNurturingAutomationConfigurationPage();

  return (
    <>
      <Helmet>
        <title>Nurturing Automation</title>
        <meta
          name="description"
          content="Enable or disable nurturing automation for the selected dealership"
        />
      </Helmet>
      <DealerRequiredPageShell
        hasDealer={hasDealer}
        breadcrumbsList={breadcrumbsList}
        pageTitle="Nurturing Automation"
        headerSubtitle={
          hasDealer ? (
            <DealerPageHeaderEntityInfo
              title={dealerTitle}
              dealerId={dealerId}
            />
          ) : undefined
        }
        contentVariant="centered"
      >
        <DealerNurturingAutomationSettingsComponent defaultExpanded />
      </DealerRequiredPageShell>
    </>
  );
};

export default withResourceProtection(
  NurturingAutomationConfigurationPage,
  CONFIGURE_RESOURCE_NURTURING_AUTOMATION,
);
